import { Link } from "react-router-dom";
import Colors from "../utils/colors";
import Footer from "../components/footer";
import Header from "../components/header";



function Page404(){
return (
<>
    <Header />
    <div className="flex-center" style={{minHeight:"12em"}}>
        <div className="flex-center" style={{padding:"3em 1.5em", flexDirection:'column', marginTop:"6em"}}>
            <br /><br/>
            <div className="h2 bold">404</div>
            <div className="h5 bold" style={{margin:"10px"}}>Page not found</div>
            <div style={{color:Colors.primary, cursor:"pointer"}}>
                <Link to={"/"} >Go back </Link>
            </div>
            <br/>
        </div>
    </div>
    <Footer/>
</>
)
}
export default Page404;